(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["process-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.process-flow__carousel[data-enable-carousel="true"]');
  if (carousel && window.innerWidth > 992) {
    const cards = carousel.querySelectorAll('.process-flow__card');
    let currentIndex = 0;

    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');
    prevBtn.className = 'process-flow__carousel-btn prev';
    nextBtn.className = 'process-flow__carousel-btn next';
    prevBtn.innerHTML = '&#10094;';
    nextBtn.innerHTML = '&#10095;';
    carousel.parentElement.appendChild(prevBtn);
    carousel.parentElement.appendChild(nextBtn);

    function updateCarousel() {
      carousel.style.transform = `translateX(-${currentIndex * 33.333}%)`;
    }

    prevBtn.addEventListener('click', () => {
      currentIndex = (currentIndex > 0) ? currentIndex - 1 : cards.length - 3;
      updateCarousel();
    });

    nextBtn.addEventListener('click', () => {
      currentIndex = (currentIndex < cards.length - 3) ? currentIndex + 1 : 0;
      updateCarousel();
    });

    carousel.style.transition = 'transform 0.5s ease';
  }
});

  } catch(e) { console.error(e); }
})();
})();
